import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Alert from '../common/Alert';
import LoadingSpinner from '../common/LoadingSpinner';

/** Signup form.
 *
 * Shows form and manages update to state on changes.
 * On submission:
 * - calls signup function prop
 * - redirects to /bookshelf route
 *
 * Routes -> SignupForm -> Alert
 * Routed as /signup
 */

function SignupForm({ signup }) {
	const history = useHistory();
	const [ formData, setFormData ] = useState({
		username: '',
		password: '',
		firstname: '',
		lastname: '',
		email: ''
	});
	const [ formErrors, setFormErrors ] = useState([]);
	const [ loading, setLoading ] = useState(false);

	console.debug('SignupForm', 'signup=', typeof signup, 'formData=', formData, 'formErrors=', formErrors);

	if (loading) {
		return (
			<div className="d-flex justify-content-center mt-3">
				<LoadingSpinner />;
			</div>
		);
	}

	/** Handle form submit:
   *
   * Calls login func prop and, if successful, redirect to /bookshelf.
   */

	async function handleSubmit(evt) {
		evt.preventDefault();
		setLoading(true);
		let result = await signup(formData);
		if (result.success) {
			setLoading(false);
			history.push('/about');
		} else {
			setFormErrors(result.errors);
		}
	}

	/** Update form data field */
	function handleChange(evt) {
		const { name, value } = evt.target;
		setFormData((data) => ({ ...data, [name]: value }));
	}

	return (
		<div className="SignupForm">
			<div className="container col-md-6 offset-md-3 col-lg-4 offset-lg-4">
				<h2 className="mb-3">Sign Up</h2>
				<div className="card">
					<div className="card-body">
						<form onSubmit={handleSubmit}>
							<div className="form-group">
								<label>Username</label>
								<input
									name="username"
									className="form-control"
									value={formData.username}
									onChange={handleChange}
								/>
							</div>
							<div className="form-group">
								<label>Password</label>
								<input
									type="password"
									name="password"
									className="form-control"
									value={formData.password}
									onChange={handleChange}
								/>
							</div>

							<div className="form-group">
								<label>First Name</label>
								<input
									name="firstname"
									className="form-control"
									value={formData.firstname}
									onChange={handleChange}
								/>
							</div>
							<div className="form-group">
								<label>Last Name</label>
								<input
									name="lastname"
									className="form-control"
									value={formData.lastname}
									onChange={handleChange}
								/>
							</div>
							<div className="form-group">
								<label>Email</label>
								<input
									type="email"
									name="email"
									className="form-control"
									value={formData.email}
									onChange={handleChange}
								/>
							</div>

							{formErrors.length ? <Alert type="danger" messages={formErrors} /> : null}

							<button type="submit" className="btn btn-primary float-right" onSubmit={handleSubmit}>
								Submit
							</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
}

export default SignupForm;
